customElements.define('product-card', class ProductCard extends HTMLElement {
  constructor() {
    super()

    this.swatchButtons = this.querySelectorAll('.color-swatch-button');
    this.swatchButtons.forEach(swatch => {
      swatch.addEventListener('mouseover', this.onSwatchHover.bind(this));
      swatch.addEventListener('click', this.onSwatchClick.bind(this));
    });
  }

  onSwatchHover() {
    const image = event.currentTarget.dataset.image;
    if (image) {
      this.preloadImage(image);
      this.querySelector('.product-card-image').setAttribute('src', image);

      event.currentTarget.addEventListener('mouseout', () => {
        const initialImage = this.querySelector('.color-swatch-item.selected .color-swatch-button').dataset.image;
        this.querySelector('.product-card-image').setAttribute('src', initialImage);
      });
    }
  }

  onSwatchClick(event) {
    const color = this.dataset.color;

    // Change active state
    this.querySelector('.color-swatch-item.selected').classList.remove('selected');
    event.currentTarget.closest('.color-swatch-item').classList.add('selected');

    // Swap out link
    const link = event.currentTarget.dataset.link;
    [...this.querySelectorAll('a')].forEach(el => {
      el.setAttribute('href', link);
    });

    // Change image
    const image = event.currentTarget.dataset.image;
    if (image) this.querySelector('.product-card-image').setAttribute('src', image);

    // Change title
    const title = event.currentTarget.dataset.title;
    if (title) this.querySelector('.product-card-title').innerHTML = title;
  }

  preloadImage(url) {
    const img = new Image();
    img.src = url;
  }
});
